import { Component, ComponentFactoryResolver, Input, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { baseUrls } from 'src/app/appConstant';
import { GlobalServices } from 'src/app/global.services';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent implements OnInit {
  starRating = 3;//extra keyword for old comment code used 
  hostedUrl = baseUrls;
  displayWishlist = true; // extra keyword till API response 
  @Input('productInfo')productInfo;
  constructor(
    private globalService: GlobalServices,
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private router: Router,
    private httpService: ApiService
  ) { }

  ngOnInit(): void {
    // console.log('ngOnInit_productInfo', this.productInfo);
  }

  public async addToWishlist(ind, event, id) {
    event.stopPropagation();
    event.preventDefault();
    let wishList: any;
    if (this.globalService.isBrowser) {
      if (this.globalService.isLoggedIn) {
        this.globalService.wishlistStatus = false;
        wishList = await this.globalService.wishList('product', id,  'shop');
        if(ind){
          // console.log('addToWishlist');
          wishList.subscribe(res=>{
            if(res && res['success'] ){
              this.productInfo.isWishlist = 1;
            }
            else{
              this.productInfo.isWishlist = 0;
            }
          });
        }
      } else {
        this.openloginmodal();
      }
    }
  }
  openloginmodal() {
    this.globalService.viewcontainerhelper = this.viewContainerRef;
    this.globalService.triggerlogin(this.viewContainerRef, this.componentFactoryResolver);
  }

  openProductInNewTab(productInfo){
      // Converts the route into a string that can be used 
  // with the window.open() function
  const url = this.router.serializeUrl(
    this.router.createUrlTree([`shopwell/product/${productInfo?.slug}`])
  );

  window.open(url, '_blank');

  }
  public async addToCart(productInfo, event, id) {
    event.stopPropagation();
    event.preventDefault();
    let objForCart = {
      pay: "fullamount",
      productId: this.productInfo?._id,
      type: "shop",
  
      productInfo: {
        bookingStartDate: "",
        bookingEndDate: "",
        accommodationId: '',
        noOfPeople: "",
        addonsId: '',
        quantity: 1,
        variantId: this.productInfo?.variationsData[0]?._id,
        color: this.productInfo?.variationsData[0]?.color?.name,
        
        size: this.productInfo?.variationsData[0]?.size,
        productType: this.productInfo?.productType == "simple" ? this.productInfo?.productType : 'variable',
        dimension: this.productInfo?.variationsData[0]?.dimension,
        weight: this.productInfo?.variationsData[0]?.weight,
        flavour: this.productInfo?.variationsData[0]?.flavour,
        
        colorCode: this.productInfo?.variationsData[0]?.color?.hexCode,
        shippingInUSA : this.productInfo?.shippingInUSA,
        shippingOutUSA : this.productInfo?.shippingOutUSA,
      }
     }
    this.addtocartForShopProduct(objForCart)
  }

  addtocartForShopProduct(dataObjectPassed){
    // console.log('addtocartForOneToOne', dataObjectPassed); return
    if (this.globalService.isBrowser) {
      // console.log(localStorage.getItem('cartquantity'));
      if (Number(localStorage.getItem('cartquantity')) >= 0 && localStorage.getItem("cartquantity") !== null){
        if (this.globalService.isLoggedIn) {
          const headerDict = { token: localStorage.getItem('userToken') };
                   
              let newdatum = {data: [dataObjectPassed]};
              let Url = "cartservice/create";
              this.httpService.postFormDataBilling(Url, newdatum, headerDict).subscribe(response => {
                // console.log('addtocartForOneToOne1_response',response);
                if (response.status ) {
                  localStorage.setItem('cartquantity', String(response.count - 1));
                  this.globalService.cartquantity = response.count;
                  this.productInfo.isCart = 1;
                  // this.showAlert = true;
                  // this.responseMessage = "You've added this item to your cart !";
                  // this.showButtonsForCartAndContinue = true;
                } 
                else {
                  this.productInfo.isCart = 0;
                  // this.showAlert = true;
                  // this.responseMessage = "You've already added this item to your cart !";
                  // this.showButtonsForCartAndContinue = false;
                }
              });
        }
        else {
        var arr = [];
        arr = JSON.parse(localStorage.getItem('cartdata'));
        // console.log(arr);
        let addedOneToOneItemPresentInCart = false;
        arr.forEach(el => {
          if(el?.productId == dataObjectPassed?.productId){
            addedOneToOneItemPresentInCart = true;
            return;
          }
        });
        if(!addedOneToOneItemPresentInCart){
          var a = [];
          a = JSON.parse(localStorage.getItem('cartdata'));
          dataObjectPassed['attr'] = dataObjectPassed?.productInfo;
          dataObjectPassed['image'] = this.productInfo?.productImage[0]?.image;
          dataObjectPassed['programName'] = this.productInfo?.title; // name of shop will be assign to key "programName" for CHECKOUT functionality working
          dataObjectPassed['programId'] = this.productInfo?._id; // for logic in checkout when user is not logged in
          dataObjectPassed['categoryName'] = "Shop";
          dataObjectPassed['fullAmount'] = this?.productInfo?.salePrice ? this.productInfo?.salePrice : this.productInfo?.regularPrice;
          dataObjectPassed['payPrice'] = this.productInfo?.salePrice ? this.productInfo?.salePrice : this.productInfo?.regularPrice;
          dataObjectPassed['totalDeposit'] = this.productInfo?.salePrice ? this.productInfo?.salePrice : this.productInfo?.regularPrice;
          dataObjectPassed['totalAddonsValue'] = 0;
          dataObjectPassed['quantity'] = 1;
          dataObjectPassed['shippingInUSA'] = this.productInfo?.shippingInUSA;
          dataObjectPassed['shippingOutUSA'] = this.productInfo?.shippingOutUSA;
          a.push(dataObjectPassed);
          localStorage.setItem('cartdata', JSON.stringify(a));
          let cartquantity = Number(localStorage.getItem('cartquantity'));
          localStorage.setItem('cartquantity', String(cartquantity + 1));
          this.globalService.cartquantity = Number(localStorage.getItem('cartquantity')) + 1;
          this.productInfo.isCart = 1;
          // this.responseMessage = "You've added this item to your cart!";
          // this.showAlert = true;
          // this.showButtonsForCartAndContinue = true;
        } 
        else {
          this.productInfo.isCart = 0;
          // this.responseMessage = "You've already added this item to your cart!";
          // this.showAlert = true;
          // this.showButtonsForCartAndContinue = false;
        } 
      }
      }
      else {
        if (this.globalService.isLoggedIn) {
          const headerDict = { token: localStorage.getItem('userToken') };
          let newdata = { data: [dataObjectPassed] };
          let Url = "cartservice/create";
          this.httpService.postFormDataBilling(Url, newdata, headerDict).subscribe(response => {
            // console.log(response);
            if (response.status ) {
              localStorage.setItem('cartquantity', String(response.count - 1));
              this.globalService.cartquantity = response.count;
              this.productInfo.isCart = 1;
              // this.responseMessage = "You've added this item to your cart!";
              // this.showAlert = true;
              // this.showButtonsForCartAndContinue = true;
            } else {
              this.productInfo.isCart = 0;
              // this.responseMessage = "You've already added this item to your cart!";
              // this.showAlert = true;
              // this.showButtonsForCartAndContinue = false;
            }
          });
        } 
        else {
            var a = [];
            a = JSON.parse(localStorage.getItem('cartdata')) || [];
            a.push(dataObjectPassed);
            dataObjectPassed['attr'] = dataObjectPassed?.productInfo;
            dataObjectPassed['image'] = this.productInfo?.productImage[0]?.image;
            dataObjectPassed['programName'] = this.productInfo?.title; // name of shop will be assign to key "programName" for CHECKOUT functionality working
            dataObjectPassed['programId'] = this.productInfo?._id; // for logic in checkout when user is not logged in
            dataObjectPassed['categoryName'] = "Shop";
            dataObjectPassed['fullAmount'] = this.productInfo?.salePrice ? this.productInfo?.salePrice : this.productInfo?.regularPrice;
            dataObjectPassed['payPrice'] = this.productInfo?.salePrice ? this.productInfo?.salePrice : this.productInfo?.regularPrice;
            dataObjectPassed['totalDeposit'] = this.productInfo?.salePrice ? this.productInfo?.salePrice : this.productInfo?.regularPrice;
            dataObjectPassed['totalAddonsValue'] = 0;
            dataObjectPassed['quantity'] = 1;
            dataObjectPassed['shippingInUSA'] = this.productInfo?.shippingInUSA;
            dataObjectPassed['shippingOutUSA'] = this.productInfo?.shippingOutUSA;
            
            localStorage.setItem('cartdata', JSON.stringify(a));
            localStorage.setItem('cartquantity', '0');
            this.globalService.cartquantity = Number(localStorage.getItem('cartquantity')) + 1;
            // this.responseMessage = "You've added this item to your cart!";
            // this.showAlert = true;
            // this.showButtonsForCartAndContinue = true;
        }
      }
    }
   
   }
}
